//加载公共样式
require('./assets/flat-ui/css/vendor/bootstrap/css/bootstrap.min.css');
require('./css/common.css');
// require('./assets/wangeditor/css/wangEditor.min.css');
require('./assets/wangeditor/js/wangEditor.min.js');

var Vue = require('vue');
var VueRouter = require('vue-router');//路由
var VueResource = require('vue-resource');//通信

var App = Vue.extend(require('./app.vue'));

Vue.use(VueRouter);
Vue.use(VueResource);

var router = new VueRouter({
	hashbang : true,
	linkActiveClass : 'custom-active-class'
});
console.log("弄啥呢");
require('./routers')(router);
router.start(App,'#app');


/*****************
 ** WEBPACK FOOTER
 ** ./src/app.js
 ** module id = 1
 ** module chunks = 0
 **/